<template>
  <div v-show="isLoaded" class="mRegistre_container" v-observe-visibility="startAnimate">
    <img class="mRegistre_img" :src="banner_registre" alt="Banner registro">
    <h2 class="mRegistre_title" :class="{animate: animate}">Registro</h2>
    <h3 class="mRegistre_subtitle" :class="{animate: animate}">Para poder participar en cualquier torneo oficial de MPT es <br>
        obligatorio estar registrado y contar con su carnet de jugador
    </h3>
    <div class="mRegistre_registre">
        <h4 class="mRegistre_subtitle_two" :class="{animate: animate}">Registro de carnet $250 <br>
            Inscripción $900 <br> <br>
            Registrarse al 8135863629
        </h4>
    </div>
  </div>
</template>

<script>
import banner_registre from '@/assets/home/registre_two.jpeg'
import { mapGetters } from "vuex";
import Bowser from "bowser"; 
export default {
    name: "Registre",
    data() {
        return {
            animate: false,
            isSafari: false,
            banner_registre,
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true;
            }
        },
    },
    mounted() {},
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Registre.scss";
</style>